/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Thu May 09 2024
 **/

import { EventHandler } from "@rfice/eventhandler";

import { EventID, SidebarID } from "@/frameworks/core/commons";
import { useSidebarActions } from "../useSidebar";

export default function useCreateSpaceUIActions() {
	const sidebarActions = useSidebarActions();

	const open = (groupId: string) => {
		EventHandler.emit(EventID.OPEN_CREATE_SPACE, {
			payload: {
				groupId
			}
		});
	};

	const close = () => {
		sidebarActions.hide(SidebarID.CreateSpace);
	};

	return {
		open,
		close
	};
}
